import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
    const { auth } = useContext(AuthContext);

    // ✅ Redirect to login if token is missing
    return auth ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
